import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import emailjs from "emailjs-com";
import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import SimpleMap from "../components/SimpleMap"; // vagy LeafletMap

const TITLE = Config.SITE_TITLE + " | Contact";
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const ContactEn = () => {
  const form = useRef();
  const navigate = useNavigate();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, // Az EmailJS szolgáltatás ID a .env fájlból
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // Az EmailJS sablon ID a .env fájlból
        form.current,
        process.env.REACT_APP_EMAILJS_USER_ID // A felhasználói azonosító a .env fájlból
      )
      .then(
        (result) => {
          console.log(result.text);
          navigate("/hu/koszonjuk");
        },
        (error) => {
          console.log(error.text);
          alert("Hiba történt az üzenet küldésekor.");
        }
      );
  };

  return (
    <main className="contact-main-content">
      <Helmet>
        <title>Contact | Csillag Masszázs Pedikűr</title>
        <meta
          name="description"
          content="Contact us, make an appointment for a massage or pedicure. Phone number, address, opening hours, form and map."
        />
        <link rel="canonical" href={`${Config.SITE_DOMAIN}/hu/Contact`} />
      </Helmet>
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact pt-4 ps-3">Contact</h1>
        </div>

        <div className="contact-content-container w-75">
          <h1>My service locations</h1>

          <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
            <SimpleMap />
          </div>

          {/* Nyitvatartás + cím */}
          <div className="mb-4">
            <h2>Opening hours</h2>
            <h3>Delice Eden Beauty Salon</h3>
            <p>
              <strong>Saturday:</strong> 10:00 – 18:00
            </p>
            <p>
              <strong>Sunday:</strong> 10:00 – 18:00
            </p>
            <h3>In the comfort of your home</h3>
            <p>
              <strong>Monday – Friday:</strong> 18:00 – 21:00
            </p>
            <h4 className="contact-margin-y1">
              Contact us to schedule a massage or pedicure.
            </h4>
            <h2 className="mt-4">Availability</h2>
            <p>
              <strong>Cím:</strong> <strong>Delice Éden Szalon:</strong> 1038
              Budapest, Éden utca 8.
            </p>
            <p>
              <strong>Cím:</strong> <strong>Az Ön otthonában</strong> 3063
              Jobbágyi, Fáy András út 12.
            </p>
            <p>
              <strong>Phone:</strong>{" "}
              <a href="tel:+36201234567">+36 20 123 4567</a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:info@janoseszter.com?subject=Kérdés%20a%20szolgáltatásokkal%20kapcsolatban&body=Kedves%20Eszter,%0D%0A%0D%0AÉrdeklődöm%20a%20szolgáltatások%20iránt.%20Szeretnék%20több%20információt%20kapni%20a%20következő%20témában:%0D%0A%0D%0A[Írd%20be%20ide%20a%20kérdéseidet%20vagy%20megjegyzéseidet]%0D%0A%0D%0AÜdvüzlettel,%0D%0AJános%20Eszter"
                target="_top"
              >
                info@janoseszter.com
              </a>
            </p>
            <p>
              Facebook:{" "}
              <a
                href="https://www.facebook.com/profile.php?id=61551742774521"
                target="blank"
              >
                Csillag masszázs pedikűr
              </a>
            </p>
            {/* Gombok */}
            <div className="mt-3 d-flex gap-3">
              <a href="tel:+36201234567" className="btn btn-success">
                📞 Hívás
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=1234+Budapest,+Minta+utca+1"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                🗺️ Route planning
              </a>
            </div>
          </div>

          {/* Form that sends email */}
          <form
            ref={form}
            onSubmit={sendEmail}
            className="contact-margin-y contact-color"
          >
            <h2>
              <b>Or send us a message via the form below</b>
            </h2>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputVezNev" className="form-label">
                Last name <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="vezeteknev"
                placeholder="Last name"
                required
              />
            </div>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputKeresztNev" className="form-label">
                First name <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="keresztnev"
                placeholder="First name"
                required
              />
            </div>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputEmail1" className="form-label">
                Email cím: <span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="E-mail cím"
                required
              />
              <div id="emailHelp" className="form-text">
                We never share your email address with others.
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="comment">
                Üzenet: <span>*</span>
              </label>
              <textarea
                className="form-control"
                rows="5"
                name="comment"
                required
              ></textarea>
            </div>
            <div className="mt-4 mb-4 form-check">
              <h6>
                By clicking the Save button, I acknowledge that I have read,
                understood and accept the Privacy Policy, on the basis of which
                the site processes my data.
              </h6>
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
                required
              />
              <label className="form-check-label" htmlFor="exampleCheck1">
                I consent to the use of my personal data by Csillag Masszázs
                Pedikúr - until my consent is withdrawn - for direct marketing
                purposes (information, public opinion or market research, or
                other information).
              </label>
            </div>
            <button type="submit" className="btn btn-outline-primary">
              Send
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default ContactEn;
